<nav
  class="main-nav"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  [class.expanded]="sidebarExpanded"
  [class.collapsed]="!sidebarExpanded"
>
  <ul class="top-nav" *ngIf="permissionService.hasUtility">
    <li>
      <svg
        *ngIf="utilityIcon == ''"
        width="48"
        height="34"
        viewBox="0 0 48 34"
        fill="red"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24 34C33.3888 34 41 26.3888 41 17C41 7.61116 33.3888 0 24 0C14.6112 0 7 7.61116 7 17C7 26.3888 14.6112 34 24 34ZM23.6419 32.4489L16.9045 3.26871C16.433 3.51285 15.9757 3.78057 15.5341 4.0703L22.3397 32.3648C22.7687 32.4107 23.2031 32.4389 23.6419 32.4489ZM21.6872 32.2811C14.2499 31.1649 8.54702 24.7484 8.54702 17C8.54702 15.5459 8.74786 14.1387 9.12332 12.8046L21.6872 32.2811ZM39.453 17C39.453 24.7484 33.7501 31.1649 26.3128 32.2811L38.8767 12.8046C39.2521 14.1387 39.453 15.5459 39.453 17ZM24.3581 32.4489C24.7969 32.4389 25.2313 32.4107 25.6603 32.3648L32.4659 4.07029C32.0243 3.78057 31.567 3.51285 31.0955 3.26871L24.3581 32.4489Z"
          fill="var(--primary-color)"
        />
      </svg>
      <img
        (click)="onNavClick('dashboard')"
        *ngIf="utilityIcon != ''"
        [src]="utilityIcon"
        width="48"
        height="48"
      />
      <p class="title sidebar-label">CAIMS</p>
    </li>
    <li
      (click)="onNavClick('map')"
      (mouseenter)="hoveredItem = 'map'"
      (mouseleave)="hoveredItem = ''"
      [ngClass]="{ active: activeItem == 'map' }"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.75 17.75V6.25C2.75 4.86929 3.86929 3.75 5.25 3.75H7V15.25H5.25C3.86929 15.25 2.75 16.3693 2.75 17.75ZM20.25 6.96429C20.25 9.64286 17 11.25 17 11.25C17 11.25 13.75 9.64286 13.75 6.96429C13.75 5.18908 15.2051 3.75 17 3.75C18.7949 3.75 20.25 5.18908 20.25 6.96429Z"
          [attr.stroke]="
            activeItem == 'map' || tooltipText == 'map' || hoveredItem == 'map'
              ? 'var(--primary-color)'
              : '#171717'
          "
          [attr.fill]="
            activeItem == 'map' || hoveredItem == 'map'
              ? 'var(--primary-color)'
              : 'none'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linecap="square"
        />
        <path
          d="M2.75 17.75C2.75 19.1307 3.86929 20.25 5.25 20.25H20.25V12.75M10.75 6.75H7"
          [attr.stroke]="
            activeItem == 'map' || tooltipText == 'map' || hoveredItem == 'map'
              ? 'var(--primary-color)'
              : '#171717'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linecap="square"
        />
      </svg>
      <p class="sidebar-label" *ngIf="sidebarExpanded">
        {{ "MAIN_SIDEBAR.MAP" | translate }}
      </p>
    </li>
    <li
      *ngIf = "permissionService.hasDashboardConfigAIDroneMap && (permissionService.isAIUAVOverviewAllowed || permissionService.isAIUAVBatchImageImportAllowed 
      || permissionService.isAIUAVSegmentationListAllowed || permissionService.isAIUAVJobMonitoringAllowed)"
      (click)="onNavClick('ai')"
      (mouseenter)="hoveredItem = 'ai'"
      (mouseleave)="hoveredItem = ''"
      [ngClass]="{ active: activeItem == 'ai' }"
    >
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.52778 17.372L1.75 20.2291
            M6.75 19.6577L5.08333 21.372
            M2.75 12.372C2.75 12.372 6.51997 14.142 8.25 15.872
            C9.98003 17.602 11.75 21.372 11.75 21.372
            L15.25 18.122V15.122
            C19.25 13.122 21.75 9.87199 21.25 2.87199
            C14.25 2.37199 11 4.872 9 8.87201H6
            L2.75 12.372Z"
          [attr.stroke]="
            activeItem == 'ai' || hoveredItem == 'ai'
              ? 'var(--primary-color)'
              : '#171717'
          "
          [attr.fill]="
            activeItem == 'ai' || hoveredItem == 'ai'
              ? 'var(--primary-color)'
              : 'none'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />

        <path
          d="M17.25 8.62199
            C17.25 9.58849 16.4665 10.372 15.5 10.372
            C14.5335 10.372 13.75 9.58849 13.75 8.62199
            C13.75 7.65549 14.5335 6.87199 15.5 6.87199
            C16.4665 6.87199 17.25 7.65549 17.25 8.62199Z"
          [attr.stroke]="
            activeItem == 'ai' || hoveredItem == 'ai' ? '#fff' : '#171717'
          "
          [attr.fill]="'#fff'"
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <p *ngIf="sidebarExpanded" class="sidebar-label">
        {{ "MAIN_SIDEBAR.AI" | translate }}
      </p>
    </li>
    <li
      (click)="onNavClick('dashboard')"
      (mouseenter)="hoveredItem = 'dashboard'"
      (mouseleave)="hoveredItem = ''"
      [ngClass]="{ active: activeItem == 'dashboard' }"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.75 13C22.75 7.61523 18.3848 3.25 13 3.25C7.61523 3.25 3.25 7.61523 3.25 13C3.25 18.3848 7.61523 22.75 13 22.75C18.3848 22.75 22.75 18.3848 22.75 13Z"
          [attr.stroke]="
            activeItem == 'dashboard' ||
            hoveredItem == 'dashboard' ||
            tooltipText == 'dashboard'
              ? 'var(--primary-color)'
              : '#171717'
          "
          [attr.fill]="
            activeItem == 'dashboard' || hoveredItem == 'dashboard'
              ? 'var(--primary-color)'
              : 'none'
          "
          stroke-opacity="0.35"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.25 10.8333L13.2708 16.7917M21.125 17.3333H4.875"
          [attr.stroke]="
            activeItem == 'dashboard' || hoveredItem == 'dashboard'
              ? '#fff'
              : tooltipText == 'dashboard'
              ? 'var(--primary-color)'
              : '#171717'
          "
          [attr.stroke-opacity]="
            activeItem == 'dashboard' || hoveredItem == 'dashboard'
              ? '1'
              : '0.35'
          "
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <p *ngIf="sidebarExpanded" class="sidebar-label">
        {{ "MAIN_SIDEBAR.ANALYTICS" | translate }}
      </p>
    </li>
    <li
      (click)="onNavClick('network-assets')"
      (mouseenter)="hoveredItem = 'network-assets'"
      (mouseleave)="hoveredItem = ''"
      [ngClass]="{ active: activeItem == 'network-assets' }"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.5 12H16.5V8
                  M7.5 12V8
                  M7.5 12V16"
          [attr.stroke]="
            activeItem == 'network-assets' ||
            hoveredItem == 'network-assets' ||
            tooltipText == 'network-assets'
              ? 'var(--primary-color)'
              : '#171717'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linejoin="round"
        />

        <path
          d="M10.25 5.5C10.25 7.01878 9.01878 8.25 7.5 8.25C5.98122 8.25 4.75 7.01878 4.75 5.5C4.75 3.98122 5.98122 2.75 7.5 2.75C9.01878 2.75 10.25 3.98122 10.25 5.5Z
                  M19.25 5.5C19.25 7.01878 18.0188 8.25 16.5 8.25C14.9812 8.25 13.75 7.01878 13.75 5.5C13.75 3.98122 14.9812 2.75 16.5 2.75C18.0188 2.75 19.25 3.98122 19.25 5.5Z
                  M10.25 18.5C10.25 20.0188 9.01878 21.25 7.5 21.25C5.98122 21.25 4.75 20.0188 4.75 18.5C4.75 16.9812 5.98122 15.75 7.5 15.75C9.01878 15.75 10.25 16.9812 10.25 18.5Z"
          [attr.fill]="
            activeItem == 'network-assets' || hoveredItem == 'network-assets'
              ? 'var(--primary-color)'
              : 'none'
          "
          [attr.stroke]="
            activeItem == 'network-assets' ||
            hoveredItem == 'network-assets' ||
            tooltipText == 'network-assets'
              ? 'var(--primary-color)'
              : '#171717'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
      </svg>
      <p *ngIf="sidebarExpanded" class="sidebar-label">
        {{ "MAIN_SIDEBAR.NETWORK_ASSET" | translate }}
      </p>
    </li>
    <!-- dummyClick zameniti sa onNavClick kad dodje customer list page na red -->
    <li
      (click)="dummyClick('customers')"
      (mouseenter)="hoveredItem = 'customers'"
      (mouseleave)="hoveredItem = ''"
      [ngClass]="{ active: activeItem == 'customers' }"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.9995 2.75C16.9325 2.75 18.4995 4.317 18.4995 6.25C18.4995 8.183 16.9325 9.75 14.9995 9.75
                  M20.7495 20.25H22.2495C22.8018 20.25 23.257 19.7995 23.1706 19.254C22.7666 16.7041 20.847 14.4288 18.2495 13.5088"
          [attr.stroke]="
            activeItem == 'customers' ||
            tooltipText == 'customers' ||
            hoveredItem == 'customers'
              ? 'var(--primary-color)'
              : '#171717'
          "
          [attr.stroke-opacity]="
            activeItem == 'customers' || hoveredItem == 'customers'
              ? '1'
              : '0.35'
          "
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.24947 9.75C7.31648 9.75 5.74947 8.183 5.74947 6.25C5.74947 4.317 7.31648 2.75 9.24947 2.75C11.1825 2.75 12.7495 4.317 12.7495 6.25C12.7495 8.183 11.1825 9.75 9.24947 9.75Z
                  M1.07662 19.2224C1.62873 15.6693 5.07746 12.75 9.24947 12.75C13.4215 12.75 16.8702 15.6693 17.4223 19.2224C17.5071 19.7682 17.0518 20.2188 16.4995 20.2188H1.99947C1.44719 20.2187 0.991811 19.7682 1.07662 19.2224Z"
          [attr.fill]="
            activeItem == 'customers' || hoveredItem == 'customers'
              ? 'var(--primary-color)'
              : 'none'
          "
          [attr.stroke]="
            activeItem == 'customers' ||
            hoveredItem == 'customers' ||
            tooltipText == 'customers'
              ? 'var(--primary-color)'
              : '#171717'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <p *ngIf="sidebarExpanded" class="sidebar-label">
        {{ "MAIN_SIDEBAR.CUSTOMERS" | translate }}
      </p>
    </li>
    <li
      (click)="onNavClick('asset-list')"
      (mouseenter)="hoveredItem = 'asset-list'"
      (mouseleave)="hoveredItem = ''"
      [ngClass]="{ active: activeItem == 'asset-list' }"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2 5.75C2 5.33579 2.33579 5 2.75 5H21.25C21.6642 5 22 5.33579 22 5.75C22 6.16421 21.6642 6.5 21.25 6.5H2.75C2.33579 6.5 2 6.16421 2 5.75ZM2 12C2 11.5858 2.33579 11.25 2.75 11.25H21.25C21.6642 11.25 22 11.5858 22 12C22 12.4142 21.6642 12.75 21.25 12.75H2.75C2.33579 12.75 2 12.4142 2 12ZM2 18.25C2 17.8358 2.33579 17.5 2.75 17.5H11.5C11.9142 17.5 12.25 17.8358 12.25 18.25C12.25 18.6642 11.9142 19 11.5 19H2.75C2.33579 19 2 18.6642 2 18.25Z"
          [attr.fill]="
            activeItem == 'asset-list' ||
            tooltipText == 'asset-list' ||
            hoveredItem == 'asset-list'
              ? 'var(--primary-color)'
              : '#171717'
          "
          fill-opacity="0.35"
        />
      </svg>
      <p *ngIf="sidebarExpanded" class="sidebar-label">
        {{ "MAIN_SIDEBAR.ASSET_LIST" | translate }}
      </p>
    </li>
    <li
      (click)="onNavClick('operations')"
      (mouseenter)="hoveredItem = 'operations'"
      (mouseleave)="hoveredItem = ''"
      [ngClass]="{ active: activeItem == 'operations' }"
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.25 14C16.2153 14 14 16.2153 14 21.25C14 16.2153 11.7847 14 6.75 14C11.7847 14 14 11.7847 14 6.75C14 11.7847 16.2153 14 21.25 14Z"
          [attr.fill]="
            activeItem == 'operations' || hoveredItem == 'operations'
              ? 'var(--primary-color)'
              : 'none'
          "
          [attr.stroke]="
            activeItem == 'operations' ||
            tooltipText == 'operations' ||
            hoveredItem == 'operations'
              ? 'var(--primary-color)'
              : '#171717'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.25 5.5C6.95139 5.5 5.5 6.95139 5.5 10.25C5.5 6.95139 4.04861 5.5 0.75 5.5C4.04861 5.5 5.5 4.04861 5.5 0.75C5.5 4.04861 6.95139 5.5 10.25 5.5Z"
          [attr.fill]="
            activeItem == 'operations' || hoveredItem == 'operations'
              ? 'var(--primary-color)'
              : 'none'
          "
          [attr.stroke]="
            activeItem == 'operations' ||
            hoveredItem == 'operations' ||
            tooltipText == 'operations'
              ? 'var(--primary-color)'
              : '#171717'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
      </svg>
      <p *ngIf="sidebarExpanded" class="sidebar-label">
        {{ "MAIN_SIDEBAR.OPERATIONS" | translate }}
      </p>
    </li>
    <li
      (click)="onNavClick('meter-management')"
      (mouseenter)="hoveredItem = 'meter-management'"
      (mouseleave)="hoveredItem = ''"
      [ngClass]="{ active: activeItem == 'meter-management' }"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 5.25V2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 10.5672 3.07575 9.21057 3.65722 8"
          [attr.stroke]="
            activeItem == 'meter-management' ||
            tooltipText == 'meter-management' ||
            hoveredItem == 'meter-management'
              ? 'var(--primary-color)'
              : '#171717'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />

        <path
          d="M10 10L5.5 5.5
                  M14.75 12C14.75 13.5188 13.5188 14.75 12 14.75C10.4812 14.75 9.25 13.5188 9.25 12C9.25 10.4812 10.4812 9.25 12 9.25C13.5188 9.25 14.75 10.4812 14.75 12Z"
          [attr.fill]="
            activeItem == 'meter-management' ||
            hoveredItem == 'meter-management'
              ? 'var(--primary-color)'
              : 'none'
          "
          [attr.stroke]="
            activeItem == 'meter-management' ||
            tooltipText == 'meter-management' ||
            hoveredItem == 'meter-management'
              ? 'var(--primary-color)'
              : '#171717'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <p *ngIf="sidebarExpanded" class="sidebar-label">
        {{ "MAIN_SIDEBAR.METER_MANAGEMENT" | translate }}
      </p>
    </li>
    <li
      *ngIf="permissionService.hasDashboardConfigReadings && permissionService.isReadingsAllowed"
      (click)="onNavClick('readings')"
      (mouseenter)="hoveredItem = 'readings'"
      (mouseleave)="hoveredItem = ''"
      [ngClass]="{ active: activeItem == 'readings' }"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.25 6.75V2.75H2.75V17.25H6.75"
          [attr.stroke]="
            activeItem == 'readings' ||
            tooltipText == 'readings' ||
            hoveredItem == 'readings'
              ? 'var(--primary-color)'
              : '#171717'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.32626 21.25H6.75V6.75H21.25V21.25H18.6737"
          [attr.stroke]="
            activeItem == 'readings' ||
            tooltipText == 'readings' ||
            hoveredItem == 'readings'
              ? 'var(--primary-color)'
              : '#171717'
          "
          [attr.fill]="
            activeItem == 'readings' || hoveredItem == 'readings'
              ? 'var(--primary-color)'
              : 'none'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.32626 21.25C9.78713 18.9642 11.7046 17.25 14 17.25C16.2954 17.25 18.2129 18.9642 18.6737 21.25M9.32626 21.25H18.6737M16.25 12.5C16.25 13.7426 15.2426 14.75 14 14.75C12.7574 14.75 11.75 13.7426 11.75 12.5C11.75 11.2574 12.7574 10.25 14 10.25C15.2426 10.25 16.25 11.2574 16.25 12.5Z"
          [attr.stroke]="
            activeItem == 'readings' || hoveredItem == 'readings'
              ? '#fff'
              : tooltipText == 'readings'
              ? 'var(--primary-color)'
              : '#171717'
          "
          [attr.fill]="
            activeItem == 'readings' || hoveredItem == 'readings'
              ? '#fff'
              : 'none'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <p *ngIf="sidebarExpanded" class="sidebar-label">
        {{ "MAIN_SIDEBAR.READINGS" | translate }}
      </p>
    </li>
    <li
      (click)="onNavClick('settings')"
      (mouseenter)="hoveredItem = 'settings'"
      (mouseleave)="hoveredItem = ''"
      [ngClass]="{ active: activeItem == 'settings' }"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5031 3.61179C11.4297 3.0783 12.5703 3.0783 13.4969 3.6118L18.7469 6.63449C19.6769 7.16992 20.25 8.16129 20.25 9.23437V14.7654C20.25 15.8385 19.6769 16.8299 18.7469 17.3653L13.4968 20.388C12.5702 20.9215 11.4297 20.9215 10.5031 20.388L5.25319 17.3656C4.32319 16.8302 3.75 15.8388 3.75 14.7657V9.23435C3.75 8.16126 4.32316 7.16989 5.25313 6.63447L10.5031 3.61179Z"
          [attr.fill]="
            activeItem == 'settings' || hoveredItem == 'settings'
              ? 'var(--primary-color)'
              : 'none'
          "
          [attr.stroke]="
            activeItem == 'settings' ||
            tooltipText == 'settings' ||
            hoveredItem == 'settings'
              ? 'var(--primary-color)'
              : '#171717'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linecap="square"
        />
        <path
          d="M15.25 12C15.25 13.795 13.795 15.25 12 15.25C10.2051 15.25 8.75 13.795 8.75 12C8.75 10.2051 10.2051 8.75 12 8.75C13.795 8.75 15.25 10.2051 15.25 12Z"
          [attr.fill]="
            activeItem == 'settings' || hoveredItem == 'settings'
              ? '#fff'
              : 'none'
          "
          [attr.stroke]="
            activeItem == 'settings' ||
            tooltipText == 'settings' ||
            hoveredItem == 'settings'
              ? 'var(--primary-color)'
              : '#171717'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linecap="square"
        />
      </svg>
      <p *ngIf="sidebarExpanded" class="sidebar-label">
        {{ "MAIN_SIDEBAR.SETTINGS" | translate }}
      </p>
    </li>
    <li (click)="logout()">
      <a class="nav-item logout" routerLinkActive="item-active">
        <img src="../../../assets/icons/logout-icon.svg" alt="Log out icon" />
      </a>
      <p *ngIf="sidebarExpanded" class="sidebar-label">
        {{ "MAIN_SIDEBAR.LOGOUT" | translate }}
      </p>
    </li>
  </ul>
  <!-- BPS ADMIN -->
  <ul class="top-nav" *ngIf="!permissionService.hasUtility">
    <li>
      <svg
        width="48"
        height="34"
        viewBox="0 0 48 34"
        fill="red"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24 34C33.3888 34 41 26.3888 41 17C41 7.61116 33.3888 0 24 0C14.6112 0 7 7.61116 7 17C7 26.3888 14.6112 34 24 34ZM23.6419 32.4489L16.9045 3.26871C16.433 3.51285 15.9757 3.78057 15.5341 4.0703L22.3397 32.3648C22.7687 32.4107 23.2031 32.4389 23.6419 32.4489ZM21.6872 32.2811C14.2499 31.1649 8.54702 24.7484 8.54702 17C8.54702 15.5459 8.74786 14.1387 9.12332 12.8046L21.6872 32.2811ZM39.453 17C39.453 24.7484 33.7501 31.1649 26.3128 32.2811L38.8767 12.8046C39.2521 14.1387 39.453 15.5459 39.453 17ZM24.3581 32.4489C24.7969 32.4389 25.2313 32.4107 25.6603 32.3648L32.4659 4.07029C32.0243 3.78057 31.567 3.51285 31.0955 3.26871L24.3581 32.4489Z"
          fill="var(--primary-color)"
        />
      </svg>
      <p class="title sidebar-label">CAIMS</p>
    </li>
    <li
      (click)="onNavClick('dashboard-bps')"
      (mouseenter)="hoveredItem = 'dashboard-bps'"
      (mouseleave)="hoveredItem = ''"
      [ngClass]="{ active: activeItem == 'dashboard-bps' }"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.75 13C22.75 7.61523 18.3848 3.25 13 3.25C7.61523 3.25 3.25 7.61523 3.25 13C3.25 18.3848 7.61523 22.75 13 22.75C18.3848 22.75 22.75 18.3848 22.75 13Z"
          [attr.stroke]="
            activeItem == 'dashboard-bps' ||
            hoveredItem == 'dashboard-bps' ||
            tooltipText == 'dashboard-bps'
              ? 'var(--primary-color)'
              : '#171717'
          "
          [attr.fill]="
            activeItem == 'dashboard-bps' || hoveredItem == 'dashboard-bps'
              ? 'var(--primary-color)'
              : 'none'
          "
          stroke-opacity="0.35"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.25 10.8333L13.2708 16.7917M21.125 17.3333H4.875"
          [attr.stroke]="
            activeItem == 'dashboard-bps' || hoveredItem == 'dashboard-bps'
              ? '#fff'
              : tooltipText == 'dashboard-bps'
              ? 'var(--primary-color)'
              : '#171717'
          "
          [attr.stroke-opacity]="
            activeItem == 'dashboard-bps' || hoveredItem == 'dashboard-bps'
              ? '1'
              : '0.35'
          "
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <p *ngIf="sidebarExpanded" class="sidebar-label">
        {{ "SIDENAV.DASHBOARD" | translate }}
      </p>
    </li>
    <li
      (click)="onNavClick('job-history')"
      (mouseenter)="hoveredItem = 'job-history'"
      (mouseleave)="hoveredItem = ''"
      [ngClass]="{ active: activeItem == 'job-history' }"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 4.12109C10.4477 4.12109 10 4.56881 10 5.12109H14C14 4.56881 13.5523 4.12109 13 4.12109H11ZM16 5.12109C16 3.46424 14.6569 2.12109 13 2.12109H11C9.34315 2.12109 8 3.46424 8 5.12109H6C4.34315 5.12109 3 6.46424 3 8.12109V18.1211C3 19.7779 4.34315 21.1211 6 21.1211C6 21.6734 6.44772 22.1211 7 22.1211C7.55228 22.1211 8 21.6734 8 21.1211H16C16 21.6734 16.4477 22.1211 17 22.1211C17.5523 22.1211 18 21.6734 18 21.1211C19.6569 21.1211 21 19.7779 21 18.1211V8.12109C21 6.46424 19.6569 5.12109 18 5.12109H16ZM9 9.12109C9.55228 9.12109 10 9.56881 10 10.1211V16.1211C10 16.6734 9.55228 17.1211 9 17.1211C8.44772 17.1211 8 16.6734 8 16.1211V10.1211C8 9.56881 8.44772 9.12109 9 9.12109ZM15 9.12109C15.5523 9.12109 16 9.56881 16 10.1211V16.1211C16 16.6734 15.5523 17.1211 15 17.1211C14.4477 17.1211 14 16.6734 14 16.1211V10.1211C14 9.56881 14.4477 9.12109 15 9.12109Z"
          [attr.stroke]="
            activeItem == 'job-history' ||
            hoveredItem == 'job-history' ||
            tooltipText == 'job-history'
              ? 'var(--primary-color)'
              : '#171717'
          "
          [attr.fill]="
            activeItem == 'job-history' || hoveredItem == 'job-history'
              ? 'var(--primary-color)'
              : 'none'
          "
          stroke-opacity="0.35"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <p *ngIf="sidebarExpanded" class="sidebar-label">
        {{ "SIDENAV.BACKGROUND_JOB_HISTORY" | translate }}
      </p>
    </li>
    <li
      (click)="onNavClick('assets')"
      (mouseenter)="hoveredItem = 'assets'"
      (mouseleave)="hoveredItem = ''"
      [ngClass]="{ active: activeItem == 'assets' }"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.75 5.87109C3.75 4.76652 4.64543 3.87109 5.75 3.87109H8.25C9.35457 3.87109 10.25 4.76652 10.25 5.87109V8.37109C10.25 9.47566 9.35457 10.3711 8.25 10.3711H5.75C4.64543 10.3711 3.75 9.47566 3.75 8.37109V5.87109Z"
          [attr.stroke]="
            activeItem == 'assets' ||
            hoveredItem == 'assets' ||
            tooltipText == 'assets'
              ? 'var(--primary-color)'
              : '#171717'
          "
          [attr.fill]="
            activeItem == 'assets' || hoveredItem == 'assets'
              ? 'var(--primary-color)'
              : 'none'
          "
          stroke-opacity="0.35"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.75 15.8711C3.75 14.7665 4.64543 13.8711 5.75 13.8711H8.25C9.35457 13.8711 10.25 14.7665 10.25 15.8711V18.3711C10.25 19.4757 9.35457 20.3711 8.25 20.3711H5.75C4.64543 20.3711 3.75 19.4757 3.75 18.3711V15.8711Z"
          [attr.stroke]="
            activeItem == 'assets' ||
            hoveredItem == 'assets' ||
            tooltipText == 'assets'
              ? 'var(--primary-color)'
              : '#171717'
          "
          [attr.fill]="
            activeItem == 'assets' || hoveredItem == 'assets'
              ? 'var(--primary-color)'
              : 'none'
          "
          stroke-opacity="0.35"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.75 17.1211C13.75 15.3262 15.2051 13.8711 17 13.8711C18.7949 13.8711 20.25 15.3262 20.25 17.1211C20.25 18.916 18.7949 20.3711 17 20.3711C15.2051 20.3711 13.75 18.916 13.75 17.1211Z"
          [attr.stroke]="
            activeItem == 'assets' ||
            hoveredItem == 'assets' ||
            tooltipText == 'assets'
              ? 'var(--primary-color)'
              : '#171717'
          "
          [attr.fill]="
            activeItem == 'assets' || hoveredItem == 'assets'
              ? 'var(--primary-color)'
              : 'none'
          "
          stroke-opacity="0.35"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.75 5.87109C13.75 4.76652 14.6454 3.87109 15.75 3.87109H18.25C19.3546 3.87109 20.25 4.76652 20.25 5.87109V8.37109C20.25 9.47566 19.3546 10.3711 18.25 10.3711H15.75C14.6454 10.3711 13.75 9.47566 13.75 8.37109V5.87109Z"
          [attr.stroke]="
            activeItem == 'assets' ||
            hoveredItem == 'assets' ||
            tooltipText == 'assets'
              ? 'var(--primary-color)'
              : '#171717'
          "
          [attr.fill]="
            activeItem == 'assets' || hoveredItem == 'assets'
              ? 'var(--primary-color)'
              : 'none'
          "
          stroke-opacity="0.35"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <p *ngIf="sidebarExpanded" class="sidebar-label">
        {{ "SIDENAV.UTILITY_ASSET_CUSTOMERS" | translate }}
      </p>
    </li>
    <li
      (click)="onNavClick('audit-log')"
      (mouseenter)="hoveredItem = 'audit-log'"
      (mouseleave)="hoveredItem = ''"
      [ngClass]="{ active: activeItem == 'audit-log' }"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.001 20.1211V18.1211C15.001 16.4642 16.3441 15.1211 18.001 15.1211H20.001M9.00098 9.12109H15.001M9.00098 13.1211H11.001M20.001 14.8785V7.12109C20.001 5.46424 18.6579 4.12109 17.001 4.12109H7.00098C5.34413 4.12109 4.00098 5.46424 4.00098 7.12109V17.1211C4.00098 18.778 5.34413 20.1211 7.00098 20.1211H14.7584C15.554 20.1211 16.3171 19.805 16.8797 19.2424L19.1223 16.9998C19.6849 16.4372 20.001 15.6741 20.001 14.8785Z"
          [attr.stroke]="
            activeItem == 'audit-log' ||
            hoveredItem == 'audit-log' ||
            tooltipText == 'audit-log'
              ? 'var(--primary-color)'
              : '#171717'
          "
          [attr.fill]="
            activeItem == 'audit-log' || hoveredItem == 'audit-log'
              ? 'var(--primary-color)'
              : 'none'
          "
          stroke-opacity="0.35"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <p *ngIf="sidebarExpanded" class="sidebar-label">
        {{ "SIDENAV.AUDIT_LOG" | translate }}
      </p>
    </li>
        <li
      (click)="onNavClick('settings-bps')"
      (mouseenter)="hoveredItem = 'settings'"
      (mouseleave)="hoveredItem = ''"
      [ngClass]="{ active: activeItem == 'settings' }"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5031 3.61179C11.4297 3.0783 12.5703 3.0783 13.4969 3.6118L18.7469 6.63449C19.6769 7.16992 20.25 8.16129 20.25 9.23437V14.7654C20.25 15.8385 19.6769 16.8299 18.7469 17.3653L13.4968 20.388C12.5702 20.9215 11.4297 20.9215 10.5031 20.388L5.25319 17.3656C4.32319 16.8302 3.75 15.8388 3.75 14.7657V9.23435C3.75 8.16126 4.32316 7.16989 5.25313 6.63447L10.5031 3.61179Z"
          [attr.fill]="
            activeItem == 'settings' || hoveredItem == 'settings'
              ? 'var(--primary-color)'
              : 'none'
          "
          [attr.stroke]="
            activeItem == 'settings' ||
            tooltipText == 'settings' ||
            hoveredItem == 'settings'
              ? 'var(--primary-color)'
              : '#171717'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linecap="square"
        />
        <path
          d="M15.25 12C15.25 13.795 13.795 15.25 12 15.25C10.2051 15.25 8.75 13.795 8.75 12C8.75 10.2051 10.2051 8.75 12 8.75C13.795 8.75 15.25 10.2051 15.25 12Z"
          [attr.fill]="
            activeItem == 'settings' || hoveredItem == 'settings'
              ? '#fff'
              : 'none'
          "
          [attr.stroke]="
            activeItem == 'settings' ||
            tooltipText == 'settings' ||
            hoveredItem == 'settings'
              ? 'var(--primary-color)'
              : '#171717'
          "
          stroke-opacity="0.35"
          stroke-width="1.5"
          stroke-linecap="square"
        />
      </svg>
      <p *ngIf="sidebarExpanded" class="sidebar-label">
        {{ "MAIN_SIDEBAR.SETTINGS" | translate }}
      </p>
    </li>
    <li (click)="logout()">
      <a class="nav-item logout" routerLinkActive="item-active">
        <img src="../../../assets/icons/logout-icon.svg" alt="Log out icon" />
      </a>
      <p *ngIf="sidebarExpanded" class="sidebar-label">
        {{ "MAIN_SIDEBAR.LOGOUT" | translate }}
      </p>
    </li>
  </ul>
  <ul class="bottom-nav">
    <li>
      <div class="notifications">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 17.25C16 19.4591 14.2091 21.25 12 21.25C9.79086 21.25 8 19.4591 8 17.25M18.4965 8.90897L18.6704 12.3526C18.692 12.7793 18.8044 13.1964 19.0002 13.5761L20.1381 15.7831C20.2116 15.9256 20.25 16.0837 20.25 16.2441C20.25 16.7996 19.7996 17.25 19.2441 17.25H4.75593C4.20037 17.25 3.75 16.7996 3.75 16.2441C3.75 16.0837 3.78835 15.9256 3.86186 15.7831L4.9998 13.5761C5.19559 13.1964 5.30802 12.7793 5.32957 12.3526L5.50351 8.90897C5.6766 5.45882 8.53386 2.75 12 2.75C15.4661 2.75 18.3234 5.45882 18.4965 8.90897Z"
            stroke="#171717"
            stroke-opacity="0.35"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </li>
    <li>
      <div class="language-selector">
        <div
          class="language-dropdown"
          (click)="showLanguageDropdown = !showLanguageDropdown"
          click-stop-propagation
        >
          <span>
            <img
              [src]="'../../assets/icons/' + selectedLanguage + '-flag.png'"
              alt="Language flag"
            />
          </span>
        </div>
        <div class="language-dropdown-opened" *ngIf="showLanguageDropdown">
          <div (click)="changeLanguage(0)">
            <img src="../../assets/icons/en-flag.png" alt="English flag" />
            <span>English</span>
          </div>
          <div (click)="changeLanguage(1)">
            <img src="../../assets/icons/fr-flag.png" alt="French flag" />
            <span>French</span>
          </div>
        </div>
      </div>
    </li>
    <li>
      <div class="profile">
        <span>{{ loggedUser }}</span>
      </div>
      <p class="sidebar-label">{{ username }}</p>
    </li>
  </ul>
</nav>
